<script lang="ts">import { Button } from "@infinitro/button";
import { cfgCdnBase, cfgEventThemeCdnPath, cfgToThemeCdnPath, isEventAssetEnabled, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, logOut, ModalDialog, pushModal, toSiteUrl } from "@infinitro/global";
import { LocalIcon, RemoteIcon } from "@infinitro/icons";
import { onMount } from "svelte";
import Logo from "./logo.svelte";
import ToggleSidebarButton from "./toggle-sidebar-button.svelte";
export let onShowPlayerChat;
const CDN_BASE = cfgCdnBase();
let navElement;
const handleLogin = () => {
	pushModal(ModalDialog.Auth, { tab: "login" });
};
const handleSignup = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
const handleLogout = () => {
	logOut();
};
onMount(() => {
	// Set event theme navbar background if active
	if (navElement && isEventAssetEnabled("navbarBackground")) {
		const navbarBgPath = cfgEventThemeCdnPath("navbarbg.png");
		if (navbarBgPath) {
			navElement.style.setProperty("--event-navbar-bg", `url('${navbarBgPath}')`);
		}
	}
	const preventScroll = (event) => {
		const targetElement = event.target;
		if (targetElement.closest(".nav-header-allow-wheel-scroll")) {
			return;
		}
		if (targetElement.closest(".nav-header")) {
			event.preventDefault();
		}
	};
	document.addEventListener("touchmove", preventScroll, { passive: false });
	document.addEventListener("wheel", preventScroll, { passive: false });
	return () => {
		document.removeEventListener("touchmove", preventScroll);
		document.removeEventListener("wheel", preventScroll);
	};
});
$: useAlternative = $stateUi.header.headerStyle === "alternative";
$: useAlternative2 = $stateUi.header.headerStyle === "alternative2";
$: useAlternative4 = $stateUi.header.headerStyle === "alternative4";
$: buttonVariant = $stateUi.header.buttonLoginVariant || "tertiary";
</script>

<nav
	class="nav-header"
	class:nav-header-alternative={useAlternative || useAlternative2 || useAlternative4}
	class:nav-header-alternative-2={useAlternative2}
	class:nav-header-alternative-4={useAlternative4}
	class:event-theme={isEventAssetEnabled('navbarBackground')}
	bind:this={navElement}
>
	<div class="menu">
		<div class="leftnav">
			<ToggleSidebarButton />
			<Logo />
		</div>
		<div class="rightnav">
			<div class="rightnav2">
				<div class="buttons">
					{#if !$stateUi.header.hideVipButtonOnLogout}
						<a
							href={toSiteUrl('/vip/', $loggedIn)}
							class="vip"
							class:vip-alternative={useAlternative || useAlternative4}
							class:vip-alternative-2={useAlternative2}
							class:vip-alternative-4={useAlternative4}
							style={useAlternative || useAlternative4
								? ''
								: useAlternative2
									? ``
									: `background-image: url('${CDN_BASE}/images/misc/vip-bg.png');`}
						>
							{#if useAlternative4}
								<LocalIcon icon="VipIcon" size={18} />
							{:else}
								<RemoteIcon
									icon="VipIcon"
									size={useAlternative2 ? 24 : 18}
									replaceFill={useAlternative2 ? false : true}
									color={useAlternative ? 'white' : 'black'}
								/>
							{/if}
							<span
								class="vip"
								class:vip-alternative={useAlternative || useAlternative2 || useAlternative4}
								class:vip-alternative-2={useAlternative2}
								>{useAlternative2 ? $t(Verbiage.vip_galaxy) : 'VIP'}</span
							>
						</a>
					{/if}
					{#if !$loggedIn}
						<Button
							text={`${$t(Verbiage.log_in)}`}
							id="login"
							variant={buttonVariant}
							onClick={handleLogin}
							whiteSpace="nowrap"
							styleCustom="overflow: hidden; min-width: 90px;"
						></Button>
						<Button
							text={`${$t(Verbiage.sign_up)}`}
							id="signUp"
							variant="primary"
							styleCustom="overflow: hidden; min-width: 90px;"
							onClick={handleSignup}
							whiteSpace="nowrap"
						></Button>
					{:else}
						<button class="register btn-register" on:click={handleLogout}>
							{$t(Verbiage.log_out)}
						</button>
					{/if}
				</div>
			</div>
		</div>
	</div>
</nav>

<style>
	nav {
		z-index: 10;
		height: 72px;
		width: 100%;
		border-bottom-width: 1px;
		border-color: var(--color-neutral-900);
		background-color: var(--color-background-700);
		--tw-bg-opacity: 1;
		padding-left: 0px;
		padding-right: 0px;
		vertical-align: middle;
		--tw-backdrop-blur: blur(50px);
		backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
		position: fixed;
}

	nav.event-theme::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-image: var(--event-navbar-bg);
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		opacity: 0.1;
		z-index: -1;
		pointer-events: none;
	}

	.nav-header-alternative {
		border-width: 0px;
		background-image: var(--gradient-alternative-4);
}

	@media (min-width: 1024px) {

		.nav-header-alternative {
				border-bottom-width: 1px;
		}
}

	.nav-header-alternative-2 {
		border-color: transparent;
		backdrop-filter: none;
		-webkit-backdrop-filter: none;
}

	@media (min-width: 1024px) {

		.nav-header-alternative-4 {
				border-bottom-width: 0px;
		}
}

	.nav-header-alternative-4 {
		background-image: none;
		background-color: var(--color-background-700);
		backdrop-filter: none;
		-webkit-backdrop-filter: none;
	}

	div.menu {
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: space-between;
		padding-left: 0.875rem;
		padding-right: 0.875rem;
}
	div.leftnav {
		display: flex;
		align-items: center;
		gap: 1.5rem;
}
	div.rightnav {
		display: flex;
		height: 4rem;
		align-items: center;
		padding-top: 0px;
		padding-bottom: 0px;
		padding-left: 0px;
		padding-right: 0px;
}
	div.rightnav2 {
		position: relative;
		display: flex;
		align-items: center;
}
	@media (min-width: 768px) {
		.rightnav-left {
				padding-right: 1.5rem; /* hidden */
		}
	}
	a.vip {
		display: flex;
		height: 2.5rem;
		width: 100%;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		border-top-width: 0.5px;
		--tw-border-opacity: 1;
		border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
		background-color: var(--color-highlight-3);
		padding: 0.5rem;
		padding-left: 0.75rem;
		padding-right: 0.75rem;
		background-size: cover;
		background-position: center;
		border-radius: var(--border-radius-header-vip);
		box-shadow: var(--shadow-vip);
}
	@media (min-width: 768px) {
		a.vip {
				width: auto;
				padding-left: 1rem;
				padding-right: 1rem;
		}
	}
	a.vip-alternative {
		border-width: 2px;
		border-color: var(--color-highlight-3);
		background-color: transparent;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		padding-left: 1rem;
		padding-right: 1rem;
		--tw-shadow: 0 0 #0000;
		--tw-shadow-colored: 0 0 #0000;
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
		background-image:
			linear-gradient(180deg, transparent 0%, transparent 100%),
			linear-gradient(
				to top,
				rgba(255, 255, 255, 0.1) 0%,
				rgba(255, 255, 255, 0) 25%,
				rgba(255, 255, 255, 0) 100%
			);
}
	a.vip-alternative-4 {
		--tw-shadow: 0 0 #0000;
		--tw-shadow-colored: 0 0 #0000;
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
		color: var(--color-text-100);
		border-radius: var(--border-radius-button);
		border-width: 0px;
		background-color: var(--color-secondary-500);
		background-image: unset;
}
	a.vip-alternative-2 {
		position: relative;
		border-style: none;
		background-color: transparent;
		--tw-shadow: 0 0 #0000;
		--tw-shadow-colored: 0 0 #0000;
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
		background: radial-gradient(
			100% 300% at 50% -150%,
			rgba(var(--color-vip-1-rgb) / 0.6) 0%,
			rgba(var(--color-vip-2-rgb) / 0.6) 100%
		);
		box-shadow:
			inset 0px 0px 5px 0px var(--color-vip-1),
			0px 0px 5px 2px var(--color-vip-1),
			inset 0px 4px 7px -3px rgba(255, 255, 255, 0.3);
}
	a.vip-alternative-2::before {
		position: absolute;
		inset: 0px;
		border-radius: 8px;
		padding: 1px;
		content: '';
		background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 100%);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 2;
}
	span.vip {
		margin-left: 0.25rem;
		display: none;
		padding-top: 1px;
		font-size: 0.75rem;
		line-height: 1rem;
		font-weight: 600;
		letter-spacing: 1px;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
}
	@media (min-width: 768px) {
		span.vip {
				display: block;
		}
	}
	span.vip-alternative {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	span.vip-alternative-2 {
		font-weight: 700;
		font-family: var(--font-main);
}

	.span.vip-alternative-4 {
		font-size: 0.875rem;
		line-height: 1.25rem;
}
	div.buttons {
		display: flex;
		height: 2.5rem;
		align-items: center;
		justify-content: center;
		gap: 0.5rem;
		white-space: nowrap; /*  -sm:px-[15px] */
}
	@media (min-width: 768px) {
		div.buttons {
				padding-left: 20px;
		}
	}
	@media (min-width: 1024px) {
		div.buttons {
				margin-right: 0.75rem;
		}
	}
	button.register {
		border-radius: 0.5rem;
		background-color: var(--color-primary-500);
		padding-left: 1.5rem;
		padding-right: 1.5rem;
		padding-top: 0.75rem;
		padding-bottom: 0.75rem;
		font-size: 0.75rem;
		line-height: 1rem;
		font-weight: 800;
		text-transform: uppercase;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		--tw-shadow-color: var(--shadow-neutral);
		--tw-shadow: var(--tw-shadow-colored);
}
	button.register:focus {
		outline: 2px solid transparent;
		outline-offset: 2px;
}
	.btn-register {
		transition:
			background-color 0.3s ease 0s,
			opacity 0.3s ease 0s,
			transform 0.1s ease 0s;
		border-radius: 4px;
	}

	.btn-star-deco {
		position: absolute;
		right: 15px;
		top: calc(50% - 60px);
		width: 80px;
		height: 80px;
		pointer-events: none;
		background-repeat: no-repeat;
		background-size: contain;
		opacity: 0.5;
		mix-blend-mode: plus-lighter;
		clip-path: inset(0 0 0 0);
	}

	.btn-star-deco-2 {
		top: auto;
		bottom: -40px;
		right: auto;
		left: 30px;
		width: 80px;
		height: 80px;
		opacity: 0.5;
	}
</style>
